import { useCallback, useMemo } from 'react';
import { useNavComponentsManager } from './useNavComponentsManager';
import { useComponentsScheduler } from './internal';
export const useToggleComponent = (name, options = {
  useScheduler: false
}) => {
  const scheduler = useComponentsScheduler();
  const {
    isOpen,
    setComponentState,
    onComponentStatesMapChange
  } = useNavComponentsManager();
  const toggle = useCallback(shouldOpen => {
    const doToggle = () => {
      const isCurrentlyOpen = isOpen(name);
      const nextValue = typeof shouldOpen === 'undefined' ? !isCurrentlyOpen : shouldOpen;
      setComponentState(name, currentState => Object.assign({}, currentState, {
        isOpen: nextValue,
        isLoaded: true
      }));
    };
    if (options.useScheduler) {
      scheduler.enqueue(doToggle);
    } else {
      doToggle();
    }
  }, [isOpen, name, setComponentState, options.useScheduler, scheduler]);
  const onToggle = useCallback(subscriber => onComponentStatesMapChange(subscriber, ({
    [name]: {
      isOpen: isCurrentlyOpen
    }
  }) => isCurrentlyOpen), [name, onComponentStatesMapChange]);
  return useMemo(() => ({
    toggle,
    onToggle
  }), [onToggle, toggle]);
};